import NiyaazBookedSlotsList from "./NiyaazBookedSlotsList";

export default {
  list: NiyaazBookedSlotsList,
  label: "Niyaaz Booked Slots",
  options: { label: "Niyaaz Booked Slots" },
  name: "niyaazBookedSlots",
};
